import { render, staticRenderFns } from "./extentSelect.vue?vue&type=template&id=662551da&"
import script from "./extentSelect.vue?vue&type=script&lang=ts&"
export * from "./extentSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports